// PermissionsContext.js — thin re-export from AppDataContext
import React, { createContext } from 'react';
import { useAppData } from './AppDataContext';

const PermissionsContext = createContext({});

export const usePermissions = () => {
  const appData = useAppData();
  return {
    userProjects: appData.projects,
    projectPermissions: appData.projectPermissions,
    loading: appData.loading,
    error: appData.error,
    hasProjectPermission: appData.hasProjectPermission,
    getProjectRole: appData.getProjectRole,
    hasProjectAccess: appData.hasProjectAccess,
    getProjectAccessDetails: async () => null,
    refreshProjectPermissions: async () => null,
    getProjectsWithMinimumRole: (minRole) => {
      const levels = { viewer: 10, contributor: 20, maintainer: 30, owner: 40 };
      const min = levels[minRole] || 0;
      return appData.projects.filter((p) => {
        const perm = appData.projectPermissions[p.id];
        return perm && (levels[perm.role] || 0) >= min;
      });
    },
    loadUserProjects: appData.refreshOrganizations,
    clearPermissions: () => {},
    PERMISSION_LEVELS: { VIEWER: 'viewer', CONTRIBUTOR: 'contributor', MAINTAINER: 'maintainer' },
  };
};

export const PermissionsProvider = ({ children }) => <>{children}</>;

export default PermissionsContext;
